const riot = require('riot');

riot.tag2('modal-image-single', '<div class="container f fh s-full px8" ref="modal" onclick="{close}"> <div class="s-full f fh overflow-hidden max-h100vh"><img class="block s-full object-fit-contain" riot-src="{imagePath}"> <div class="absolute trbl0 s-full f fm flex-between"> <div class="absolute t0 b0 l0 f fh h-full text-white p32 cursor-pointer" if="{opts.index &gt; 0}" data-type="prev" onclick="{slide}"><i class="icon-arrow_left fs20"></i></div> <div class="absolute t0 b0 r0 f fh h-full text-white p32 cursor-pointer" if="{opts.index &lt; opts.images.length - 1}" data-type="next" onclick="{slide}"><i class="icon-arrow_right fs20"></i></div> </div> </div> </div>', 'modal-image-single,[data-is="modal-image-single"]{background-color:rgba(0,0,0,0.8)} modal-image-single .max-h100vh,[data-is="modal-image-single"] .max-h100vh{max-height:100vh}', 'class="f fh" spat-animation="push"', function(opts) {
    this.on('mount', () => {
      this.imagePath = this.opts.item.path;
      this.update();
    });

    this.slide = (e) => {
      e.stopPropagation();
      var type = e.currentTarget.dataset.type;
      type === 'next' ? this.opts.index++ : this.opts.index--;
      this.opts.index = this.opts.index <= 0 ? 0 :this.opts.index;
      this.opts.index = this.opts.index === this.opts.images.length -1 ? this.opts.images.length -1 : this.opts.index;
      this.imagePath = this.opts.images[this.opts.index].path;
      this.update();
    };
});